export default {
    updateUAMember(state, req) {
        state.useragent = Object.assign(state.useragent, { member: req.mem });
    },
    updateUAHeaders(state, req) {
        state.useragent = Object.assign(state.useragent, { headers: req.headers });
    },
};



// WEBPACK FOOTER //
// src/store/mutations.js